import Cookies from "js-cookie";
export class Voice {
    public activate() {
        Cookies.set('voice-on', 'true');
    }

    public disactivate() {
        Cookies.set('voice-on', 'false');
    }

    public isActive() {
        if (Cookies.get('voice-on') && Cookies.get('voice-on') === 'true') {
            return true;
        } else {
            return false;
        }
    }
}